import { render, staticRenderFns } from "./ktvOrderReserveUpdateRecord.vue?vue&type=template&id=fe6a86f0&scoped=true"
import script from "./ktvOrderReserveUpdateRecord.vue?vue&type=script&lang=ts"
export * from "./ktvOrderReserveUpdateRecord.vue?vue&type=script&lang=ts"
import style0 from "./ktvOrderReserveUpdateRecord.vue?vue&type=style&index=0&id=fe6a86f0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6a86f0",
  null
  
)

export default component.exports